export interface CalRescheduleErrorDiagnostics {
  message?: string;
  statusCode?: number;
}

/**
 * Older/self-hosted Cal builds can expose reschedule failures as a 404 against
 * `/bookings/{uid}/reschedule` instead of supporting the dedicated route.
 */
export function isUnsupportedCalRescheduleRoute({
  message,
  statusCode,
}: {
  message?: string;
  statusCode?: number;
}): boolean {
  if (statusCode !== 404) {
    return false;
  }

  const normalizedMessage = message?.toLowerCase() ?? "";
  return (
    normalizedMessage.includes("cannot post ") &&
    normalizedMessage.includes("/bookings/") &&
    normalizedMessage.includes("/reschedule")
  );
}
